"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _rebass = require("rebass");

var _styledSystem = require("styled-system");

var _mediaQueries = _interopRequireDefault(require("../../styles/mediaQueries"));

var ListWrapper = (0, _styled.default)(_rebass.Box)(function (_ref) {
  var _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      space = _ref$theme.space;
  return (0, _styledSystem.variant)({
    prop: 'bg',
    variants: {
      primary: _defineProperty({
        backgroundColor: 'transparent',
        padding: 0
      }, _mediaQueries.default.medium, {
        padding: 0
      }),
      secondary: _defineProperty({
        backgroundColor: colors.offwhite,
        padding: "".concat(space.base, " 0")
      }, _mediaQueries.default.medium, {
        padding: "".concat(space.large, " 0")
      })
    }
  });
});
var _default = ListWrapper;
exports.default = _default;